export const mergeFaqsByCategory = (
  faqs: Queries.Maybe<ReadonlyArray<Queries.Maybe<Queries.SanityFaq>>>,
): Queries.SanityFaq[] => {
  if (!faqs) return [];

  return faqs.reduce<Queries.SanityFaq[]>((sanityFaqs, current) => {
    if (!current || !current.category) return sanityFaqs;

    const acc = [...sanityFaqs];

    const existingCategoryIndex = acc.findIndex(
      (item) => item.category === current.category,
    );

    if (existingCategoryIndex > -1) {
      const existingCategory = acc[existingCategoryIndex];
      acc[existingCategoryIndex] = {
        ...existingCategory,
        faqs: [...(existingCategory.faqs || []), ...(current.faqs || [])],
      };
    } else {
      acc.push({
        ...current,
        faqs: current.faqs || [],
      });
    }

    return acc;
  }, []);
};
